import {
  Button,
  Container,
  Heading,
  HStack,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Link } from '@chakra-ui/next-js';
import { ROUTES } from '@habity/constants';
import { getSellPath } from '@habity/services';

export default function BlogCTASection() {
  return (
    <Stack backgroundColor="gray.100">
      <Container maxW="660px">
        <Stack gap="24px" justify="center" textAlign="center" py="140px">
          <Heading size="3xl" color="gray.900">
            Redo att ta nästa steg?
          </Heading>
          <Text color="gray.700" fontSize="lg">
            Vill du sälja din bostad eller bevaka nya bostäder på marknaden? Vi
            hjälper dig genom hela processen.
          </Text>
          <HStack justify="center" gap="4" flexWrap="wrap" pt="8">
            <Link href={getSellPath(undefined, 'estimate')}>
              <Button
                size="lg"
                backgroundColor="black"
                color="white"
                _hover={{ backgroundColor: 'gray.800' }}
              >
                Vad är min bostad värd?
              </Button>
            </Link>
            <Link href={ROUTES.BUY}>
              <Button
                size="lg"
                variant="outline"
                borderColor="black"
                color="black"
                _hover={{ backgroundColor: 'blackAlpha.50' }}
              >
                Skapa bostadsbevakning
              </Button>
            </Link>
          </HStack>
        </Stack>
      </Container>
    </Stack>
  );
}
